export default __webpack_public_path__ + "static/media/Band of the Sanguine Disciple.3bec8043.jpg";